<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "bold";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M8.0364 2.36358C7.68492 2.01211 7.11508 2.01211 6.7636 2.36358C6.41213 2.71505 6.41213 3.2849 6.7636 3.63637L15.1272 12L6.7636 20.3636C6.41213 20.7151 6.41213 21.2849 6.7636 21.6364C7.11508 21.9878 7.68492 21.9878 8.0364 21.6364L17.0364 12.6364C17.3879 12.2849 17.3879 11.7151 17.0364 11.3636L8.0364 2.36358Z"
    />
    <path
      v-else-if="weight === 'bold'"
      d="M9.06066 1.93934C8.47487 1.35355 7.52513 1.35355 6.93934 1.93934C6.35355 2.52513 6.35355 3.47487 6.93934 4.06066L14.8787 12L6.93934 19.9393C6.35355 20.5251 6.35355 21.4749 6.93934 22.0607C7.52513 22.6464 8.47487 22.6464 9.06066 22.0607L18.0607 13.0607C18.6464 12.4749 18.6464 11.5251 18.0607 10.9393L9.06066 1.93934Z"
    />
  </svg>
</template>
